import { render, staticRenderFns } from "./report.vue?vue&type=template&id=2f234df4&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"
import style0 from "./report.vue?vue&type=style&index=0&id=2f234df4&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f234df4",
  null
  
)

export default component.exports